import React from "react";

import useScrollAnimation from "../components/useScrollAnimation";


const experiences = [
    {
        date: "June 2024 – Jan 2026",
        role: "Backend Developer",
        type: "Full Time",
        duration: "1 Year 6 month",
        company: "Saffiretech",
        // certificate: "https://drive.google.com/your-experience-letter-link",
        projects: [
            {
                name: "Care College – Role-Based Education Platform",
                description:
                    "A scalable role-based web application for an education platform with dynamic content management and progress tracking.",
                techStack: [
                    "React.js",
                    "Node.js",
                    "PHP",
                    "MySQL",
                    "JavaScript",
                    "Headless WordPress",
                    "REST APIs",
                ],
                points: [
                    "Developed scalable role-based web application using React.js, Node.js, and Headless WordPress",
                    "Built custom REST APIs and WordPress plugins for seamless content management",
                    "Implemented complete CRUD functionality with MySQL database integration",
                    "Designed role-based progress tracking module with dynamic indicators",
                    "Developed real-time notification system to improve communication between teachers and students",
                    "Optimized internal plugins for better performance, maintainability, and code quality",
                ],
            },
            {
                name: "Mind Renaissance – Assessment & Report Automation System",
                description:
                    "A live production system for automated assessment processing and PDF report generation.",
                techStack: ["PHP", "MySQL", "JavaScript", "DOMPDF", "LearnDash", "ACF"],
                points: [
                    "Maintained and enhanced a live production website with custom backend improvements",
                    "Worked closely with clients to gather requirements and implement tailored solutions",
                    "Built automated LearnDash-based PDF reporting system using ACF metadata",
                    "Implemented phase-wise logic and performance charts in generated reports",
                    "Developed rule-based automation for automatic role assignment",
                    "Ensured accurate data handling through backend validation and logic optimization",
                ],
            },
            {
                name: "WooCommerce Plugin – Enhanced UX & AI Recommendations",
                description:
                    "A WooCommerce plugin designed to enhance user experience through dynamic product displays and AI-driven recommendations.",
                techStack: [
                    "PHP",
                    "JavaScript",
                    "AJAX",
                    "WooCommerce",
                    "WordPress",
                    "MySQL",
                    "GitLab",
                    "SVN",
                ],
                points: [
                    "Developed WooCommerce plugin with dynamic product sliders and customizable filters",
                    "Implemented AI-driven upsell and cross-sell recommendations to boost sales",
                    "Built advanced admin features including scheduling options and email notifications",
                    "Improved store management flexibility through configurable plugin settings",
                    "Managed version control and deployments using GitLab and SVN",
                    "Ensured compatibility across WordPress and WooCommerce versions",
                ],
            },
        ],

    },
    {
        date: "Oct 2022 – Nov 2022",
        role: "Software Development Intern",
        type: "Internship",
        duration: "1 Months",
        company: "HKI Infotech",
        certificate: "",
        projects: [
            {
                name: "ERP / Retail Management System",
                description:
                    "Worked on frontend and backend development for an ERP/Retail system improving data flow and business operations.",
                techStack: [
                    "Angular",
                    "TypeScript",
                    ".NET Core",
                    "REST APIs",
                    "Swagger",
                    "MSSQL",
                ],
                points: [
                    "Developed responsive UI components using Angular and TypeScript",
                    "Built and tested RESTful APIs using .NET Core with Swagger documentation",
                    "Worked with MSSQL database handling relational queries and operations",
                    "Improved frontend-backend data flow within ERP/Retail system",
                ],
            },
        ],
    },
    // {
    //     date: "June 2022 ",
    //     role: "Data Science Intern",
    //     type: "Internship",
    //     duration: "2 Weeks",
    //     company: "Vidyavardhini’s College of Engineering & Technology",
    //     certificate: "",
    //     projects: [
    //         {
    //             name: "Data Analysis & Machine Learning Training",
    //             description:
    //                 "Intensive internship focused on data preprocessing, visualization, and foundational machine learning concepts.",
    //             techStack: ["Python", "Pandas", "NumPy", "Matplotlib", "Machine Learning"],
    //             points: [
    //                 "Completed hands-on training in data analysis and preprocessing techniques",
    //                 "Worked with Python for data handling, visualization, and model building",
    //                 "Gained exposure to real-world datasets and predictive modeling techniques",
    //                 "Strengthened understanding of statistics and data-driven problem solving",
    //             ],
    //         },
    //     ],
    // },

];



/* ================= MAIN EXPERIENCE PAGE ================= */

export default function Experience() {
  return (
    <div className="container mt-5 pt-5">
      <h2 className="fw-bold mb-5">Experience</h2>

      <div className="timeline">
        {experiences.map((exp, index) => (
          <ExperienceItem key={index} exp={exp} index={index} />
        ))}
      </div>
    </div>
  );
}

function ExperienceItem({ exp , index }) {
  const ref = useScrollAnimation();
   const shouldAnimate = index > 0; 

  return (
    <div ref={shouldAnimate ? ref : null} className={`timeline-item mb-5 ${shouldAnimate ? "scroll-hidden" : ""}`}>
      <div className="timeline-dot"></div>

      <div className="timeline-content card p-4">
        <span className="small">{exp.date}</span>
        <h5 className="mt-2">
          {exp.role} – {exp.company}
        </h5>

        <div className="d-flex flex-wrap gap-2 mt-2">
          <span className="badge badge-black">{exp.type}</span>
          <span className="badge badge-black">{exp.duration}</span>
        </div>

        {exp.projects.map((project, pIndex) => (
          <div key={pIndex} className="mt-4">
            <h6 className="fw-semibold">{project.name}</h6>
            <p>{project.description}</p>

            <div className="mb-2">
              {project.techStack.map((tech, tIndex) => (
                <span key={tIndex} className="badge me-2 mb-2">
                  {tech}
                </span>
              ))}
            </div>

            <ul>
              {project.points.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

